module.exports = __webpack_public_path__ + "static/media/Lock.fc907368.svg";